var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icoClose"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"icoClose","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("polygon",{"fill":"#FCB34E","points":"18.521 1.958 11.329 9.15 18.521 16.342 16.692 18.171 9.5 10.979 2.308 18.171 0.479 16.342 7.671 9.15 0.479 1.958 2.308 0.129 9.5 7.321 16.692 0.129"}))]);
}

Close.defaultProps = {"width":"19px","height":"19px","viewBox":"0 0 19 19","version":"1.1"};

module.exports = Close;

Close.default = Close;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/icons/close.svg
// module id = 175
// module chunks = 0